// extracted by mini-css-extract-plugin
export default {"link":"aDK4_D","root":"JIkdIh","label":"myM8sv"};